import React, { Component } from 'react'
import './style.css'

class PilihBidang extends Component {
    constructor(props) {
        super(props)
        this.state = {
            bidang_selected: this.props.bidang_selected || '',
            showManualInput: false,
            manualBidang: ''
        }
    }

    bidangOptions = [
        { id: 'teknologi', label: 'Teknologi', icon: '💻', color: 'bg-blue-50' },
        { id: 'pemerintahan', label: 'Pemerintahan', icon: '🏛️', color: 'bg-green-50' },
        { id: 'fnb', label: 'F&B', icon: '🍽️', color: 'bg-orange-50' },
        { id: 'jasa', label: 'Jasa', icon: '🔧', color: 'bg-purple-50' },
        { id: 'media', label: 'Media', icon: '🎬', color: 'bg-pink-50' },
        { id: 'dll', label: 'Lainnya', icon: '✏️', color: 'bg-gray-50' }
    ]

    selectOption = (option) => {
        if (option.id === 'dll') {
            this.setState({ showManualInput: true, bidang_selected: option.id })
        } else {
            // mark selected visually then advance
            this.setState({ bidang_selected: option.id, showManualInput: false }, () => {
                // small delay so user sees selection
                setTimeout(() => {
                    this.props.setState({ bidang_selected: option.label, stepHeader: 1 })
                }, 200)
            })
        }
    }

    handleManualChange = (e) => {
        this.setState({ manualBidang: e.target.value })
    }

    submitManual = () => {
        const val = this.state.manualBidang.trim()
        if (!val) {
            alert('Masukkan bidang perusahaan')
            return
        }
        this.props.setState({ bidang_selected: val, stepHeader: 1 })
    }

    renderCard(option) {
        const isSelected = this.state.bidang_selected === option.id
        return (
            <label key={option.id} className="cursor-pointer">
                <input
                    type="radio"
                    name="bidang"
                    className="card-input-element"
                    checked={isSelected}
                    onChange={() => this.selectOption(option)}
                />
                <div className={`card card-default card-input mx-0 ${isSelected ? 'bg-selected-card' : ''}`} style={{ borderRadius: '10px', cursor: 'pointer' }}>
                    <div className="card-body d-flex flex-column align-items-center justify-content-center" style={{ minHeight: 140 }} onClick={() => this.selectOption(option)}>
                        <div className='icon-box mb-3' style={{ fontSize: 34 }}>
                            {option.icon}
                        </div>
                        <div className='card-title text-center' style={{ fontSize: '14px', fontWeight: 700, color: '#143B5E' }}>{option.label}</div>
                    </div>
                </div>
            </label>
        )
    }

    render() {
        return (
            <main style={{ marginTop: '120px', marginBottom: '50px' }}>
                <div className='container'>
                    <div className='row'>
                        <div className='col'></div>
                        <div className='col-md-8'>
                            <div className='row'>
                                <div className='col'>
                                    <div className='card border'>
                                        <div className='card-header py-2 px-3' style={{ backgroundColor: '#FAFDFF', fontSize: '18px', fontWeight: 700, color: '#143B5E' }}>Pilih Bidang Perusahaan</div>
                                        <div className='card-body px-3 py-4' style={{ backgroundColor: '#FFFFFF' }}>
                                            <div className='row'>
                                                {this.bidangOptions.map(opt => (
                                                    <div className='col-md-4 mb-3' key={opt.id}>
                                                        {this.renderCard(opt)}
                                                    </div>
                                                ))}
                                            </div>

                                            {this.state.showManualInput && (
                                                <div className='row mt-3'>
                                                    <div className='col-md-8'>
                                                        <input type='text' className='form-control' placeholder='Masukkan bidang perusahaan' value={this.state.manualBidang} onChange={this.handleManualChange} />
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <button className='btn btn-primary btn-block' onClick={this.submitManual}>Lanjutkan</button>
                                                    </div>
                                                </div>
                                            )}

                                            <div className='row mt-4'>
                                                <div className='col text-center text-muted'>Informasi bidang perusahaan membantu kami memberikan fitur yang lebih relevan untuk bisnis Anda.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col'></div>
                    </div>
                </div>
            </main>
        )
    }
}

export default PilihBidang
